import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ToolsService } from "../../../shared/services/tools/tools.service";

export const USER_AUTH_USERNAME_KEY = "SessionDataUserName";
export const USER_AUTH_PERFIL_KEY = "SessionDataPerfil";
export const USER_AUTH_TOKEN_KEY = "SessionDataToken";
export const USER_AUTH_ID_USER = "SessionDataIdUser";
export const USER_AUTH_REFRESH_TOKEN = "SessionDataRefreshToken";
export const USER_AUTH_EXP = "SessionDataExp";
export const USER_AUTH_EXP_REFRESH_TOKEN = "SessionDataExpRefreshToken";

@Injectable()
export class IdentityStorage {
  constructor(private toolsService: ToolsService) {}

  public saveAuthData(userData: any) {
    window.sessionStorage.removeItem(USER_AUTH_USERNAME_KEY);
    window.sessionStorage.removeItem(USER_AUTH_PERFIL_KEY);
    window.sessionStorage.removeItem(USER_AUTH_TOKEN_KEY);
    window.sessionStorage.removeItem(USER_AUTH_REFRESH_TOKEN);
    window.sessionStorage.removeItem(USER_AUTH_EXP);
    window.sessionStorage.removeItem(USER_AUTH_EXP_REFRESH_TOKEN);
    window.sessionStorage.setItem(USER_AUTH_USERNAME_KEY, userData.userName);
    window.sessionStorage.setItem(USER_AUTH_PERFIL_KEY, userData.perfil);
    window.sessionStorage.setItem(USER_AUTH_TOKEN_KEY, userData.token);
    window.sessionStorage.setItem(USER_AUTH_ID_USER, userData.id);
    window.sessionStorage.setItem(
      USER_AUTH_REFRESH_TOKEN,
      userData.refreshToken
    );
    window.sessionStorage.setItem(USER_AUTH_EXP, userData.exp);
    window.sessionStorage.setItem(
      USER_AUTH_EXP_REFRESH_TOKEN,
      userData.expRefreshToken
    );
  }

  public clearAuthData() {
    window.sessionStorage.removeItem(USER_AUTH_USERNAME_KEY);
    window.sessionStorage.removeItem(USER_AUTH_PERFIL_KEY);
    window.sessionStorage.removeItem(USER_AUTH_TOKEN_KEY);
    window.sessionStorage.removeItem(USER_AUTH_ID_USER);
    window.sessionStorage.removeItem(USER_AUTH_REFRESH_TOKEN);
    window.sessionStorage.removeItem(USER_AUTH_EXP);
    window.sessionStorage.removeItem(USER_AUTH_EXP_REFRESH_TOKEN);

    window.sessionStorage.clear();
  }

  public refreshAuthData(userData: any) {
    window.sessionStorage.removeItem(USER_AUTH_TOKEN_KEY);
    window.sessionStorage.removeItem(USER_AUTH_REFRESH_TOKEN);
    window.sessionStorage.removeItem(USER_AUTH_EXP);
    window.sessionStorage.removeItem(USER_AUTH_EXP_REFRESH_TOKEN);
    window.sessionStorage.setItem(USER_AUTH_TOKEN_KEY, userData.token);
    window.sessionStorage.setItem(
      USER_AUTH_REFRESH_TOKEN,
      userData.refreshToken
    );
    window.sessionStorage.setItem(USER_AUTH_EXP, userData.exp);
    window.sessionStorage.setItem(
      USER_AUTH_EXP_REFRESH_TOKEN,
      userData.expRefreshToken
    );
  }

  public authenticationPresent(): boolean {
    return window.sessionStorage.getItem(USER_AUTH_TOKEN_KEY) !== null;
  }

  public getIdentity(): any {
    const identity: any = {
      userName: sessionStorage.getItem(USER_AUTH_USERNAME_KEY),
      perfil: sessionStorage.getItem(USER_AUTH_PERFIL_KEY),
      token: sessionStorage.getItem(USER_AUTH_TOKEN_KEY),
      refreshToken: sessionStorage.getItem(USER_AUTH_REFRESH_TOKEN),
      id: sessionStorage.getItem(USER_AUTH_ID_USER),
    };
    return identity;
  }

  public getExp(): any {
    const exp: any = {
      exp: sessionStorage.getItem(USER_AUTH_EXP),
      expRefreshToken: sessionStorage.getItem(USER_AUTH_EXP_REFRESH_TOKEN),
      refreshToken: sessionStorage.getItem(USER_AUTH_REFRESH_TOKEN),
    };
    return exp;
  }

  public getIdentityPromise(): Observable<any> {
    return this.getIdentity();
  }

  public getGroups() {
    const parsed = this.toolsService.parseJwt(
      sessionStorage.getItem(USER_AUTH_TOKEN_KEY)
    );
    return parsed.groups;
  }
}
